import React, { useState } from 'react';
import { Button, Row, Col, Badge, Modal, Card } from 'react-bootstrap';
import { MedicalDocument } from '#components';
import { Document } from '#atoms';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

export const MedicalDocumentsGallery = ({ data = [], onRemove = () => {}, hideAI = false, hideRemoveButton = false }) => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  const closeModal = () => setShowModal(false);
  const openModal = (document) => setShowModal(document);

  return (
    <>
      <Row>
        {data?.map?.((document) => (
          <Col xs={12} lg={6} xl={4} key={document.id} className='mb-3'>
            <Document isMiniature>
              <Document.Title>
                {t(`title.${document.document_type.toLowerCase()}`)}
                {document.date && (
                  <div className='h6'>
                    <span>
                      {t('document-gallery.dated')} {moment(document.date).format('y-MM-DD')}
                    </span>
                  </div>
                )}
              </Document.Title>

              <Document.Subtitle>
                {document.tags?.map((tag) => (
                  <Badge key={tag} bg='primary' className='m-1'>
                    {tag}
                  </Badge>
                ))}
              </Document.Subtitle>

              {document.text_content ? (
                <Document.Truncated>{document.text_content}</Document.Truncated>
              ) : (
                <Document.BgImage url={`url(${document.images?.[0]?.signed_url})`} />
              )}

              <Document.Actions className='mt-auto'>
                <Button
                  variant='success'
                  size='sm'
                  className='mx-2'
                  onClick={() => {
                    openModal(document);
                  }}
                >
                  {t('document-gallery.view')}
                </Button>
                {!hideRemoveButton && (
                  <Button
                    variant='danger'
                    size='sm'
                    className='mx-2'
                    onClick={() => {
                      onRemove(document);
                    }}
                  >
                    {t('document-gallery.deselect')}
                  </Button>
                )}
              </Document.Actions>
            </Document>
          </Col>
        ))}
      </Row>
      <Modal size={'xl'} show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {showModal?.document_type === 'LAB'
              ? t('medical-document.lab')
              : t('medical-document.diag')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showModal?.images && showModal.images.length > 0 && (
            <Card className='mb-4'>
              <Card.Header className='text-center mb-3'>
                <h5>{t('document-form.document-images-header')}</h5>
              </Card.Header>
              <Card.Body>
                <ImageGallery
                  showFullscreenButton={true}
                  showPlayButton={false}
                  showNav={true}
                  items={showModal.images.map((image) => ({
                    original: image.signed_url,
                    thumbnail: image.thumbnail_signed_url || image.signed_url,
                  }))}
                />
              </Card.Body>
            </Card>
          )}
          <MedicalDocument data={showModal} hideAI={hideAI} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={closeModal}>
            {t('document-gallery.close')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
